/*
 * Rapi, asistentul raptors.ro: widgetul de chat pentru site.
 * Se încarcă din snippetul raptors-chat.liquid. Nu are dependențe și nu conține nicio cheie:
 * vorbește doar cu backendul (data-endpoint), care ține cheia Claude API.
 *
 * Atribute pe tagul <script>:
 *   data-endpoint   adresa backendului, ex. https://rapi-raptors.vercel.app/api/chat (obligatoriu)
 *   data-product    handle-ul produsului, pe pagina de produs (opțional)
 *   data-bottom     distanța butonului față de marginea de jos, în px (implicit 20)
 *   data-side       "right" sau "left" (implicit right)
 *   data-contact    link spre pagina de contact, afișat sub fereastră (opțional)
 *   data-hint       text mic sub buton, ex. "sau scrie-ne pe WhatsApp" (opțional)
 *   data-hint-bottom distanța textului față de marginea de jos, în px (implicit data-bottom - 30)
 */
(function () {
  "use strict";
  if (window.__rapiLoaded) return;
  window.__rapiLoaded = true;
 
  var script = document.currentScript;
  var cfg = {
    endpoint: script && script.dataset.endpoint,
    product: (script && script.dataset.product) || "",
    bottom: parseInt((script && script.dataset.bottom) || "20", 10),
    side: script && script.dataset.side === "left" ? "left" : "right",
    contact: (script && script.dataset.contact) || "",
    hint: (script && script.dataset.hint) || "",
  };
  cfg.hintBottom = parseInt((script && script.dataset.hintBottom) || String(cfg.bottom - 30), 10);
  if (!cfg.endpoint) {
    console.warn("Rapi: lipsește data-endpoint pe tagul <script>.");
    return;
  }
 
  var GREETING =
    "Salut! 👋 Sunt Rapi, asistentul Raptors. Spune-mi câți ani are copilul, cât de înalt e și pe unde vrea să meargă, și îți recomand bicicleta potrivită plus accesoriile și echipamentul de care are nevoie.";
  var STARTERS = [
    "Băiat 4 ani, 105 cm, prima lui bicicletă",
    "Fetiță 7 ani, merge des prin pădure",
    "Ce accesorii merg pe Belter 16?",
    "Belter 16 sau woom 3?",
  ];
  var SEP = "\u001e";
  var STORE_KEY = "rapi-chat-v1";
  var CAT = { balans: "Bicicletă de echilibru", bicicleta: "Bicicletă", casca: "Cască", imbracaminte: "Îmbrăcăminte", accesoriu: "Accesoriu", piesa: "Piesă" };
 
  // Conversația rămâne cât timp clientul navighează pe site (în același tab).
  var state = { open: false, turns: [] };
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null");
    if (saved && Array.isArray(saved.turns)) state = saved;
  } catch (e) {}
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }
 
  var CSS = [
    ":host{all:initial}",
    "*{box-sizing:border-box}",
    ".root{--brand:#1f5a3c;--brand-ink:#fff;--accent:#ffb627;--ink:#18231c;--muted:#5d6b61;--line:#dde3db;--bot:#eef3ec;--chip:#e6eee4;--panel:#fff;--bg:#f6f8f4;",
    "font-size:15px;line-height:1.5;color:var(--ink)}",
    ".launch{position:fixed;bottom:var(--b);height:56px;padding:0 20px 0 7px;border-radius:999px;border:0;background:var(--brand);color:var(--brand-ink);cursor:pointer;font:inherit;font-size:15px;font-weight:600;gap:8px;",
    "box-shadow:0 6px 20px rgba(0,0,0,.22);display:flex;align-items:center;z-index:2147483000;transition:transform .15s;white-space:nowrap}",
    ".launch:hover{transform:scale(1.05)}.launch:focus-visible{outline:3px solid var(--accent);outline-offset:2px}",
    ".launch .ic{width:42px;height:42px;border-radius:50%;background:var(--accent);color:var(--brand);display:grid;place-items:center;flex:none}.launch svg{width:26px;height:26px}",
    ".teaser{position:fixed;bottom:calc(var(--b) + 68px);max-width:270px;background:var(--panel);color:var(--ink);border-radius:14px;box-shadow:0 8px 28px rgba(0,0,0,.2);",
    "padding:12px 34px 12px 14px;font-size:14px;line-height:1.4;cursor:pointer;z-index:2147483000}",
    ".hint{position:fixed;bottom:var(--hb);font-size:12.5px;font-weight:600;line-height:1;color:var(--ink);background:rgba(255,255,255,.94);padding:5px 10px;border-radius:999px;",
    "box-shadow:0 2px 8px rgba(0,0,0,.15);pointer-events:none;white-space:nowrap;z-index:2147483000}.open .hint{display:none}",
    ".teaser[hidden]{display:none}.teaser b{display:block;margin-bottom:2px}",
    ".teaser .tx{position:absolute;top:4px;right:6px;border:0;background:none;font-size:18px;line-height:1;color:var(--muted);cursor:pointer;padding:4px}",
    "@media (prefers-reduced-motion:no-preference){.teaser{animation:in .25s ease-out}}",
    ".panel{position:fixed;bottom:calc(var(--b) + 72px);width:380px;max-width:calc(100vw - 24px);height:600px;max-height:calc(100vh - var(--b) - 96px);",
    "background:var(--panel);border-radius:18px;box-shadow:0 12px 40px rgba(0,0,0,.25);display:flex;flex-direction:column;overflow:hidden;z-index:2147483001}",
    ".panel[hidden]{display:none}",
    ".right{right:20px}.left{left:20px}",
    "header{display:flex;align-items:center;gap:10px;padding:12px 14px;background:var(--brand);color:var(--brand-ink)}",
    ".logo{width:36px;height:36px;border-radius:50%;background:var(--accent);display:grid;place-items:center;flex:none}.logo svg{width:22px;height:22px}",
    "header .t{flex:1;min-width:0}header b{display:block;font-size:17px;font-weight:700}header span{display:block;font-size:12px;opacity:.85}",
    "header button{font:inherit;font-size:12.5px;color:inherit;background:none;border:1px solid rgba(255,255,255,.6);border-radius:10px;padding:4px 9px;cursor:pointer;flex:none}",
    "header .x{border:0;font-size:22px;line-height:1;padding:2px 6px}",
    ".log{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;min-height:0;background:var(--panel)}",
    ".msg{max-width:88%;padding:9px 13px;border-radius:16px;overflow-wrap:anywhere}",
    ".bot{background:var(--bot);border-bottom-left-radius:5px;align-self:flex-start}",
    ".me{background:var(--brand);color:var(--brand-ink);border-bottom-right-radius:5px;align-self:flex-end;white-space:pre-wrap}",
    ".msg p{margin:0 0 6px}.msg p:last-child{margin:0}.msg ul{margin:4px 0 6px;padding-left:20px}",
    ".wait{color:var(--muted);font-style:italic}",
    ".cards{display:flex;gap:10px;overflow-x:auto;padding:2px 0 4px;align-self:stretch;flex:none}",
    ".card{flex:0 0 170px;border:1px solid var(--line);border-radius:12px;padding:8px 10px;background:var(--panel);text-decoration:none;color:var(--ink);display:flex;flex-direction:column;gap:4px}",
    "a.card:hover,a.card:focus-visible{border-color:var(--brand);outline:none}",
    ".card img{width:100%;height:96px;object-fit:contain;border-radius:8px;background:#fff}",
    ".card .cat{font-size:10.5px;text-transform:uppercase;letter-spacing:.08em;color:var(--muted)}",
    ".card b{font-size:14px;line-height:1.25}",
    ".card .row{display:flex;justify-content:space-between;align-items:baseline;gap:6px;margin-top:auto;padding-top:2px;font-size:13.5px}",
    ".price{font-weight:600}.stock{font-size:11px;padding:1px 7px;border-radius:999px;background:var(--chip);white-space:nowrap}.stock.out{color:#b3412e}",
    ".chips{display:flex;gap:8px;padding:0 14px 10px;overflow-x:auto;flex:none}",
    ".chips button{font:inherit;font-size:13px;border:1px solid var(--line);background:var(--chip);color:var(--ink);border-radius:999px;padding:6px 11px;cursor:pointer;white-space:nowrap}",
    ".chips button:hover{border-color:var(--brand)}",
    ".err{font-size:12.5px;color:#b3412e;padding:0 14px 8px;margin:0}",
    "form{display:flex;gap:8px;padding:10px 12px;border-top:1px solid var(--line)}",
    "textarea{flex:1;min-width:0;font:inherit;font-size:16px;resize:none;border:1px solid var(--line);border-radius:12px;padding:9px 11px;background:var(--bg);color:var(--ink);max-height:110px}",
    "textarea:focus{outline:2px solid var(--brand);outline-offset:-1px}",
    ".send{font:inherit;font-weight:600;border:0;border-radius:12px;padding:0 16px;background:var(--brand);color:var(--brand-ink);cursor:pointer}.send:disabled{opacity:.5;cursor:default}",
    ".foot{font-size:11.5px;color:var(--muted);text-align:center;padding:0 12px 8px;margin:0}.foot a{color:inherit}",
    "@media (max-width:640px){.open .launch{display:none}.panel{inset:0;width:100%;max-width:none;height:100%;max-height:none;border-radius:0}}",
    "@media (prefers-reduced-motion:no-preference){.msg{animation:in .18s ease-out}@keyframes in{from{transform:translateY(4px);opacity:.4}to{transform:none;opacity:1}}}",
  ].join("");
 
  var BIKE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/><path d="M5.5 16.5 9 9h6l3.5 7.5M9 9 12 16.5 15 9M8 6h3"/></svg>';
 
  // Folosim fontul temei, ca widgetul să arate ca restul site-ului.
  function storeFont() {
    var f = "";
    try { f = getComputedStyle(document.body).fontFamily; } catch (e) {}
    return f || 'system-ui,-apple-system,"Segoe UI",Roboto,sans-serif';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  }
 
  var host = document.createElement("div");
  host.id = "rapi-chat";
  // Închis, butonul stă deasupra paginii, dar sub ferestrele altor aplicații (de exemplu WhatsApp).
  // Deschis, chatul stă deasupra a tot (vezi setOpen).
  var Z_CLOSED = "1000", Z_OPEN = "2147483647";
  host.style.cssText = "position:relative;z-index:" + Z_CLOSED;
  var shadow = host.attachShadow({ mode: "open" });
  shadow.innerHTML =
    "<style>" + CSS + "</style>" +
    '<div class="root" style="--b:' + cfg.bottom + 'px;--hb:' + cfg.hintBottom + 'px;font-family:' + esc(storeFont()) + '">' +
    '<div class="teaser ' + cfg.side + '" role="status" hidden><b>Salut! 👋 Sunt Rapi.</b>Te ajut să alegi bicicleta potrivită pentru copilul tău.<button class="tx" type="button" aria-label="Închide mesajul">×</button></div>' +
    '<button class="launch ' + cfg.side + '" type="button" aria-expanded="false"><span class="ic">' + BIKE + "</span><span>Întreabă-l pe Rapi</span></button>" +
    (cfg.hint ? '<div class="hint ' + cfg.side + '" aria-hidden="true">' + esc(cfg.hint) + "</div>" : "") +
    '<section class="panel ' + cfg.side + '" role="dialog" aria-label="Chat cu Rapi" hidden>' +
    '<header><div class="logo" style="color:#18231c">' + BIKE + '</div><div class="t"><b>Rapi</b><span>Te ajut să alegi bicicleta potrivită</span></div>' +
    '<button class="new" type="button" title="Conversație nouă">Nouă</button><button class="x" type="button" aria-label="Închide">×</button></header>' +
    '<div class="log" aria-live="polite"></div><div class="chips"></div><p class="err" hidden></p>' +
    '<form><textarea rows="1" placeholder="Ex: fetiță de 5 ani, 112 cm" aria-label="Mesajul tău"></textarea><button class="send" type="submit">Trimite</button></form>' +
    '<p class="foot">Asistent automat. Pentru comenzi și retururi, ' +
    (cfg.contact ? '<a href="' + cfg.contact.replace(/"/g, "&quot;") + '">scrie-ne aici</a>' : "scrie-ne din pagina de contact") + ".</p>" +
    "</section></div>";
  document.body.appendChild(host);
 
  var $ = function (s) { return shadow.querySelector(s); };
  var root = $(".root"), teaser = $(".teaser");
  var launch = $(".launch"), panel = $(".panel"), log = $(".log"), chips = $(".chips"), err = $(".err");
  var form = $("form"), q = $("textarea"), sendBtn = $(".send");
  var busy = false, ctl = null;
 
  function md(s) {
    var lines = esc(s.trim()).split("\n"), html = "", inList = false;
    lines.forEach(function (l) {
      l = l.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
      var li = l.match(/^\s*[-•*]\s+(.*)/);
      if (li) { if (!inList) { html += "<ul>"; inList = true; } html += "<li>" + li[1] + "</li>"; return; }
      if (inList) { html += "</ul>"; inList = false; }
      if (l.trim()) html += "<p>" + l + "</p>";
    });
    if (inList) html += "</ul>";
    return html;
  }
  function stripProducts(text) {
    return text.replace(/\n?\s*PRODUSE:.*$/is, "");
  }
  function lei(n) {
    return Number(n).toLocaleString("ro-RO", { maximumFractionDigits: 2 }) + " lei";
  }
  function scroll() { log.scrollTop = log.scrollHeight; }
 
  function addMsg(role, text) {
    var d = document.createElement("div");
    d.className = "msg " + role;
    if (role === "me") d.textContent = text; else d.innerHTML = md(text);
    log.appendChild(d);
    scroll();
    return d;
  }
  function addCards(cards) {
    if (!cards || !cards.length) return;
    var wrap = document.createElement("div");
    wrap.className = "cards";
    cards.forEach(function (c) {
      var el;
      if (c.kind === "product") {
        el = document.createElement("a");
        el.href = c.url;
        el.className = "card";
        el.innerHTML =
          (c.image ? '<img src="' + esc(c.image + (c.image.indexOf("?") < 0 ? "?" : "&") + "width=300") + '" alt="" loading="lazy">' : "") +
          '<span class="cat">' + esc(CAT[c.category] || "") + (c.size ? " · " + esc(c.size) : "") + "</span><b>" + esc(c.name) + "</b>" +
          '<span class="row"><span class="price">' + lei(c.price_lei) + '</span><span class="stock' + (c.in_stock ? "" : " out") + '">' + (c.in_stock ? "în stoc" : "stoc epuizat") + "</span></span>";
        el.addEventListener("click", function () { state.open = true; save(); });
      } else {
        el = document.createElement("div");
        el.className = "card";
        el.innerHTML = '<span class="cat">Early Rider 2027' + (c.age ? " · " + esc(c.age) : "") + "</span><b>" + esc(c.name) + "</b>" +
          '<span class="row"><span class="price">Preț la cerere</span></span>';
      }
      wrap.appendChild(el);
    });
    log.appendChild(wrap);
    scroll();
  }
  function showChips() {
    chips.innerHTML = "";
    if (state.turns.length) return;
    STARTERS.forEach(function (s) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = s;
      b.onclick = function () { ask(s); };
      chips.appendChild(b);
    });
  }
  function showError(text) {
    err.hidden = !text;
    err.textContent = text || "";
  }
  function renderAll() {
    log.innerHTML = "";
    addMsg("bot", GREETING);
    state.turns.forEach(function (t) {
      addMsg(t.role === "user" ? "me" : "bot", t.role === "user" ? t.content : stripProducts(t.content));
      if (t.cards) addCards(t.cards);
    });
    showChips();
  }
 
  var mobile = window.matchMedia("(max-width:640px)");
  var touch = window.matchMedia("(pointer:coarse)");
  var vv = window.visualViewport;
 
  // Pe telefon, fereastra ocupă exact partea vizibilă a ecranului, deasupra tastaturii,
  // ca antetul și mesajele să nu iasă din ecran când apare tastatura.
  function fitMobile() {
    if (panel.hidden || !mobile.matches || !vv) { panel.style.top = panel.style.height = panel.style.bottom = ""; return; }
    panel.style.top = vv.offsetTop + "px";
    panel.style.height = vv.height + "px";
    panel.style.bottom = "auto";
    scroll();
  }
  if (vv) { vv.addEventListener("resize", fitMobile); vv.addEventListener("scroll", fitMobile); }
 
  function setOpen(open) {
    state.open = open;
    save();
    // Mutăm chatul la finalul paginii, ca butoanele adăugate mai târziu de alte aplicații să rămână sub el.
    if (open && host !== document.body.lastElementChild) document.body.appendChild(host);
    host.style.zIndex = open ? Z_OPEN : Z_CLOSED;
    panel.hidden = !open;
    launch.setAttribute("aria-expanded", String(open));
    root.classList.toggle("open", open);
    if (open) hideTeaser();
    fitMobile();
    // Pe telefon nu deschidem tastatura singuri: clientul vede întâi salutul.
    if (open) { scroll(); if (!touch.matches) setTimeout(function () { q.focus(); }, 50); }
  }
 
  async function ask(text) {
    text = text.trim();
    if (!text || busy) return;
    busy = true;
    sendBtn.disabled = true;
    chips.innerHTML = "";
    showError("");
    addMsg("me", text);
    q.value = "";
    q.style.height = "";
    var turn = { role: "user", content: text.slice(0, 1000) };
    if (cfg.product) turn.page = cfg.product;
    state.turns.push(turn);
    save();
 
    var el = addMsg("bot", "");
    el.innerHTML = '<span class="wait">Mă gândesc...</span>';
    ctl = new AbortController();
    var answer = "", tail = "";
    try {
      var res = await fetch(cfg.endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          messages: state.turns.map(function (t) {
            var m = { role: t.role, content: t.content };
            if (t.page) m.page = t.page;
            return m;
          }),
        }),
        signal: ctl.signal,
      });
      if (!res.ok || !res.body) {
        var info = await res.json().catch(function () { return {}; });
        throw new Error(info.error || "");
      }
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = "";
      for (;;) {
        var r = await reader.read();
        if (r.done) break;
        buf += dec.decode(r.value, { stream: true });
        var i = buf.indexOf(SEP);
        answer = i < 0 ? buf : buf.slice(0, i);
        tail = i < 0 ? "" : buf.slice(i + 1);
        if (answer) { el.innerHTML = md(stripProducts(answer)); scroll(); }
      }
      var meta = {};
      try { meta = tail ? JSON.parse(tail) : {}; } catch (e) {}
      if (!answer.trim()) {
        el.remove();
        state.turns.pop();
        showError(meta.error || "Ceva n-a mers. Mai trimite o dată mesajul.");
      } else {
        el.innerHTML = md(stripProducts(answer));
        addCards(meta.cards);
        state.turns.push({ role: "assistant", content: answer, cards: meta.cards || [] });
        if (meta.error) showError(meta.error);
      }
    } catch (e) {
      if (e && e.name === "AbortError") return;
      el.remove();
      state.turns.pop();
      showError((e && e.message) || "Nu mă pot conecta acum. Verifică internetul și încearcă din nou.");
    } finally {
      busy = false;
      sendBtn.disabled = false;
      ctl = null;
      save();
      if (!state.turns.length) showChips();
    }
  }
 
  function reset() {
    if (ctl) ctl.abort();
    busy = false;
    sendBtn.disabled = false;
    state.turns = [];
    save();
    showError("");
    renderAll();
    if (!touch.matches) q.focus();
  }
 
  launch.addEventListener("click", function () { setOpen(panel.hidden); });
 
  // Mesajul de salut de lângă buton: apare o singură dată pe sesiune, după câteva secunde.
  var TEASER_KEY = "rapi-teaser-v1";
  function hideTeaser() {
    teaser.hidden = true;
  }
  teaser.addEventListener("click", function () { setOpen(true); });
  $(".tx").addEventListener("click", function (e) { e.stopPropagation(); hideTeaser(); });
  var seen = false;
  try { seen = sessionStorage.getItem(TEASER_KEY) === "1"; } catch (e) {}
  if (!seen && !state.open && !state.turns.length) {
    setTimeout(function () {
      if (!panel.hidden) return;
      teaser.hidden = false;
      try { sessionStorage.setItem(TEASER_KEY, "1"); } catch (e) {}
    }, 4000);
  }
  $(".x").addEventListener("click", function () { setOpen(false); launch.focus(); });
  $(".new").addEventListener("click", reset);
  form.addEventListener("submit", function (e) { e.preventDefault(); ask(q.value); });
  q.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); ask(q.value); }
  });
  q.addEventListener("input", function () {
    q.style.height = "auto";
    q.style.height = Math.min(q.scrollHeight, 110) + "px";
  });
  shadow.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) { setOpen(false); launch.focus(); }
  });
 
  renderAll();
  if (state.open) setOpen(true);
})();